import { apiRequest } from './auth';

export const contractsAPI = {
  getAll: async () => {
    return await apiRequest('/contracts');
  },

  getByProject: async (project) => {
    return await apiRequest(`/contracts/${encodeURIComponent(project)}`);
  },

  add: async (project, contractName) => {
    return await apiRequest(`/contracts/${encodeURIComponent(project)}`, {
      method: 'POST',
      body: JSON.stringify({ contractName }),
    });
  },

  remove: async (project, contractName) => {
    return await apiRequest(`/contracts/${encodeURIComponent(project)}/${encodeURIComponent(contractName)}`, {
      method: 'DELETE',
    });
  }
};

export default contractsAPI;
